import React, { createContext, useEffect, useState } from "react";
import { ScrollTrigger } from "gsap/all";

// Global Camera Context — asks for webcam permission once
// and shares the result so artwork components can decide
// whether to render

export const CameraContext = createContext({ cameraAllowed: null });

const CameraProvider = ({ children }) => {
  const [cameraAllowed, setCameraAllowed] = useState(null);

  useEffect(() => {
    if (typeof window === "undefined" || !navigator.mediaDevices) {
      setCameraAllowed(false);
      return;
    }
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then(stream => {
        stream.getTracks().forEach(track => track.stop());
        setCameraAllowed(true);
      })
      .catch(() => setCameraAllowed(false));
  }, []);

  // When the camera decision lands, the artwork wrappers either
  // appear or get display:none, which shifts the layout. Existing
  // ScrollTriggers still hold the old start/end positions, so
  // refresh them once the DOM has reflowed.
  useEffect(() => {
    if (cameraAllowed === null) return;
    const raf = requestAnimationFrame(() => {
      requestAnimationFrame(() => ScrollTrigger.refresh());
    });
    return () => cancelAnimationFrame(raf);
  }, [cameraAllowed]);

  return (
    <CameraContext.Provider value={{ cameraAllowed }}>
      {children}
    </CameraContext.Provider>
  );
};

export default CameraProvider;
